import type { Options as Html2CanvasOptions } from "html2canvas"
import type { jsPDFOptions } from "jspdf"

/**
 * 내보내기 전용 라이브러리는 쓸 때 받아온다 (일감 #198).
 *
 * jspdf·html2canvas 는 PDF·이미지로 내보낼 때만 필요한데 정적 import 라 메인 번들(4.5MB)에
 * 들어가 있었다. 화면 진입마다 파싱 비용을 내고 있었고, 저사양 PC 에서 특히 비쌌다.
 *
 * 호출부를 바꾸지 않도록 원래와 같은 시그니처로 감쌌다 — import 문만 이 모듈로 바꾸면 된다.
 */

/** html2canvas 와 같은 시그니처. 원래도 Promise 를 돌려줬으므로 호출부가 그대로다. */
export const html2canvas = async (
  element: HTMLElement,
  options?: Partial<Html2CanvasOptions>,
): Promise<HTMLCanvasElement> => {
  const mod = await import("html2canvas")

  return mod.default(element, options)
}

/** new jsPDF(...) 대신 쓴다 — 생성자는 감쌀 수 없어 호출부를 await 로 바꿔야 한다. */
export const createJsPdf = async (options?: jsPDFOptions) => {
  const mod = await import("jspdf")

  return new mod.default(options)
}
